import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import { AcompanhamentoVistoriaController } from "../../../Controllers/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import {
    IAcompanhamentosVistoria,
    IAcompanhamentoVistoriaFiltro,
} from "../../../Interfaces/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaInterfaces";
import VisualizarFormulario from "../../Geral/Formularios/VisualizarFormulario";
import FiltroAcompanhamentosVistoria from "./FiltroAcompanhamentosVistoria";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

interface IAcompanhamentosVistoriaProps {}

const filtroInicial: IAcompanhamentoVistoriaFiltro = {
    ID_PRODUTO_PAI: [] as any,
    DT_INICIAL: "",
    DT_FINAL: "",
    PAGINA: 1,
    PESQUISA: "",
    ID_USUARIO_RESPONSAVEL: "" as any,
    DS_NOME: "",
    NR_CPF: "",
    ID_CASO: 0,
    ID_UNIDADE: [] as any,
    DS_CLASSIFICACAO: "",
};

export default function AcompanhamentosVistoria(
    props: IAcompanhamentosVistoriaProps
) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    // eslint-disable-next-line
    const [idEmpreendimento, setIdEmpreendimento] = useState<number[]>([]);

    const FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES = sessionStorage.getItem(
        "FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES"
    );

    useEffect(() => {
        if (FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES) {
            sessionStorage.setItem(
                "FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES",
                JSON.stringify({ ...filtroInicial, PESQUISA: "" })
            );
        }
    }, []);

    const { filter, setPageFilter, PageFilter, setPage, setFilter } =
        usePaginationFilter<IAcompanhamentoVistoriaFiltro>({
            page: 1,
            filter: FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES
                ? JSON.parse(FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES)
                : filtroInicial,
        });

    const {
        value: acompanhamentosVistoria,
        loading: acompanhamentosVistoriaLoading,
    } = useAsyncEffect(
        () =>
            AcompanhamentoVistoriaController({
                ...PageFilter.filter,
                PAGINA: PageFilter.page,
            }),
        [PageFilter]
    );

    const totalPages = acompanhamentosVistoria?.NR_PAGINAS;

    const tableviewColumns: Array<
        ColumnDescription<
            IAcompanhamentosVistoria["relatorioAcompanhamentoVistoria"][0]
        >
    > = [
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (c, row) => {
                return (
                    <>
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-atendimento-tooltip">
                                    Ver Formulário
                                </Tooltip>
                            }
                        >
                            <button
                                type="button"
                                className="m-2 btn btn-icon btn-outline-info"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        noHeader: true,
                                        Component: () => (
                                            <VisualizarFormulario
                                                setShow={setShow}
                                                idFormulario={row.ID_FORMULARIO}
                                                visualizandoFormRespondido={
                                                    true
                                                }
                                                idCaso={row.ID_CASO}
                                                cdEtapa={row.CD_ETAPA}
                                                exportarPdf={true}
                                                nrAgrupamento={
                                                    row.NR_AGRUPAMENTO
                                                }
                                                row={row}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                        </OverlayTrigger>
                    </>
                );
            },
        },
        {
            dataField: "ID_CASO",
            text: "Solicitação",
        },
        {
            dataField: "DS_PRODUTO",
            text: "Empreendimento",
        },
        {
            dataField: "DS_NOME",
            text: "Cliente",
        },
        {
            dataField: "DT_ASSINATURA",
            text: "Data",
            formatter: (c) => (c ? c : "-"),
        },
        {
            dataField: "DS_CATEGORIA_ATENDIMENTO_COMP",
            text: "Categoria de Atendimento",
        },
        {
            dataField: "DS_FORMULARIO",
            text: "Classificação",
        },
    ];

    const ultimaPesquisaRef = useRef("");

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    PAGINA: newState.page,
                });
                setPage(newState.page);
            }
        }, 1500);
    }
    return (
        <div className="card card-custom p-5">
            <div className="w-100 justify-content-between align-items-center mb-8 col-12 mt-3">
                <div className="justify-content-between align-items-center mb-10">
                    <h4>Relatórios Vistoria e Entrega de Chaves</h4>
                </div>
                <Table
                    columns={tableviewColumns}
                    data={
                        acompanhamentosVistoria?.relatorioAcompanhamentoVistoria ??
                        []
                    }
                    keyField="ID_CASO"
                    loading={acompanhamentosVistoriaLoading}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhum Acompanhamento de Vistoria Encontrado
                        </div>
                    )}
                    tableView={{
                        columns: tableviewColumns,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    remote={{ pagination: true, filter: true }}
                    totalPages={totalPages}
                    onTableChange={(_type, newState) => {
                        const state = newState as IPropsTableChange;
                        setPage(state.page);
                    }}
                    noHover
                    bordered={false}
                    defaultStyle={{
                        align: "center",
                        classes: "p-2",
                    }}
                    page={PageFilter.page}
                    noSearch={true}
                    striped={true}
                    rowStyle={{ height: 50 }}
                    rowClasses={"rowClasses"}
                    center={true}
                />

                <FiltroAcompanhamentosVistoria
                    handleSubmit={(formData) => {
                        setPageFilter({
                            filter: {
                                ...formData,
                                //ID_PRODUTO_PAI: idEmpreendimento,
                            },
                            page: 1,
                        });
                        setFilter(formData);
                        sessionStorage.setItem(
                            "FILTRO_RELATORIO_VISTORIAS_ENTREGA_CHAVES",
                            JSON.stringify(formData)
                        );
                    }}
                    defaultFilter={filter}
                    setIdEmpreendimento={setIdEmpreendimento}
                    idEmpreendimento={idEmpreendimento}
                />
                <ModalComponent
                    ModalComponent={modal}
                    show={show}
                    setShow={setShow}
                />
            </div>
        </div>
    );
}
